module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Datenschutz",
	"footer.privacy.url": "https://www.grohe.at/de_at/unternehmen/datenschutz.html",
	"footer.disclaimer.text": "Impressum",
	"footer.disclaimer.url": "https://www.grohe.at/de_at/unternehmen/impressum.html",
	"footer.copyright": "&copy; 2017 GROHE Gesellschaft m.b.H.",
	"homepage.headline": "GROHE SmartControl Konfigurator",
	"homepage.introtext": "Beantworten Sie einfach die unten stehenden Fragen und konfigurieren Sie Ihr persönlich auf Sie zugeschnittenes GROHE SmartControl Duschsystem.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Seite nicht gefunden",
	"404.link.goBack": "Zurück zur Startseite",
	"configurator.button.seeResults": "Ergebnisse anzeigen",
	"question1.question": "Für welchen Bereich Ihres Bades suchen Sie eine Duschlösung?",
	"question1.option1.text": "Für den Duschbereich",
	"question1.option2.text": "Für die Badewanne mit Wanneneinlauf",
	"question2.question": "Welche Installationsart bevorzugen Sie? Aufputz, Unterputz oder eine Kombination aus beidem?",
	"question2.option1.text": "Aufputz: die Lösung zur einfachen Montage auf der Wand",
	"question2.option2.text": "Kombi-Lösung: versteckte Wasserleitungen hinter der Wand und ein Thermostat mit Ablage vor der Wand",
	"question2.option3.text": "Unterputz: versteckte Technologie hinter der Wand für eine minimalistische Anmutung",
	"question3.question": "Welche Form gefällt Ihnen am besten?",
	"question3.option1.text": "Eckig",
	"question3.option2.text": "Rund",
	"question4.question": "Was möchten Sie mit SmartControl steuern?",
	"question4.option1.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question4.option2.text": "Eine zweistrahlige Kopfbrause und eine Handbrause",
	"question4.option3.text": "Eine Kopfbrause, eine Handbrause und einen Wanneneinlauf",
	"question4.option4.text": "Eine Kopfbrause, eine Handbrause und zwei Seitenbrausen",
	"question4.option5.text": "Eine Kopfbrause und eine Handbrause",
	"question4.option6.text": "Eine Handbrause und einen Wanneneinlauf",
	"question4.option7.text": "Nur eine Handbrause",
	"question4.option8.text": "Nur einen Wanneneinlauf",
	"question5.question": "Wählen Sie Ihre bevorzugte Farbe",
	"question5.option1.text": "Chrom",
	"question5.option2.text": "Weiß/Chrom",
	"question5.option3.text": "Weiß/Chrom",
	"question6.question": "Möchten Sie den Thermostat mit integriertem Handbrausehalter oder ohne?",
	"question6.option1.text": "Mit integriertem Handbrausehalter",
	"question6.option2.text": "Ohne integrierten Handbrausehalter",
	"question7.question": "Wie soll Ihre Handbrause gehalten werden?",
	"question7.option1.text": "Von einer Brausestange mit höhenverstellbarem Handbrausehalter",
	"question7.option2.text": "Von einem minimalistischen Handbrausehalter",
	"question8.question": "Möchten Sie Ihre Kopfbrause an der Wand oder an der Decke montieren?",
	"question8.option1.text": "Wandmontierte Kopfbrause",
	"question8.option2.text": "Deckenmontierte Kopfbrause",
	"results.title": "{productGroupsCount, plural, \none {Ihr Ergebnis} \nother {Ihre Ergebnisse}\n}",
	"results.proposal.title": "Ergebnis {number}",
	"results.proposal.title.single": "Ergebnis",
	"results.bundle.title": "Für die komplette Installation benötigen Sie auch noch:",
	"results.newConfiguration.title": "Wollen Sie ein neues Duschsystem konfigurieren?",
	"results.newConfiguration.buttonText": "Neue Konfiguration beginnen",
	"results.product.number": "Artikelnummer:  #{number}",
	"results.product.button.productInformation": "Produktdetails",
	"results.product.button.dealerLocator": "Ausstellungen und Installateure",
	"results.product.button.buyNow": "Online kaufen",
	"results.product.button.downloadPDF": "PDF herunterladen",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Ausstellungen und Installateure",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/de_at.json
// module id = 735
// module chunks = 0